import React from 'react'
import { LineStyles } from './Style'
import { ReactComponent as ChildIcon } from 'assets/icons/Child.svg';
import { SvgIcon } from '@mui/material'

const BarLine = (props) => {
    const { color, count, percent, ratingIndex } = props

    return (
        <LineStyles color={color} firstItem={!ratingIndex}>
            <div className='wrap-line'>
                <div className='rating-details count'>
                    {!count ||
                        <React.Fragment>
                            {count}
                            <SvgIcon fontSize={"14"} component={ChildIcon} inheritViewBox />
                        </React.Fragment>}
                </div>
                <div className='line' />
                <div className='rating-details percent'>
                    {!percent || `${percent.toFixed(0)}%`}
                </div>
            </div>
        </LineStyles>
    )
}

export default BarLine